import moment from 'moment';
import React, { useMemo } from 'react';
import Card from '../../../../common/components/Card';
import Table from '../../../../common/components/Table';
import { NavigateLink } from '@/common/components/links/NavigateLink';
import Icon from '@/common/components/Icon';

const QueueCurrentConsultant = ({ currentConsultants }) => {
	const headers = [
		'started at',
		'Consultant',
		'D.C.',
		'Status',
		'Created at Order',
		'Phone',
		'Actions',
	];

	const raws = useMemo(() => {
		if (currentConsultants) {
			return currentConsultants.map((consultant, i) => (
				<tr>
					<td style={{ padding: '10px 10px', textAlign: ' center' }}>
						{moment(consultant.updated_at).format('YYYY-MM-DD HH:mm:ss')}
					</td>
					<td style={{ padding: '10px 10px', textAlign: ' center' }}>
						{consultant._user.name + ' ' + consultant._user.surname}
					</td>
					<td style={{ padding: '10px 10px', textAlign: ' center' }}>
						{consultant.dequeued_count}
					</td>
					<td style={{ padding: '10px 10px', textAlign: ' center' }}>
						{consultant._order.status}
					</td>
					<td style={{ padding: '10px 10px', textAlign: ' center' }}>
						{moment(consultant._order.created_at).format('YYYY-MM-DD HH:mm:ss')}
					</td>
					<td style={{ padding: '10px 10px', textAlign: ' center' }}>
						{consultant?._contact?.phone_number
							?.match(/.{1,3}/g)
							.map((substring) => substring + ' ')}
					</td>
					<td
						style={{
							padding: '10px 10px',
							textAlign: ' center',
							gap: '20px',
							justifyContent: 'center',
							display: 'flex',
						}}
					>
						<NavigateLink
							target='_blank'
							to={`/dashboard/contact/${consultant._contact._id}`}
						>
							<Icon name='address-book' />
						</NavigateLink>
						<NavigateLink
							target='_blank'
							to={`/dashboard/order/${consultant._order._id}`}
						>
							<Icon name='user' />
						</NavigateLink>
					</td>
				</tr>
			));
		}
	}, [currentConsultants]);

	return (
		currentConsultants &&
		currentConsultants.length > 0 && (
			<Card>
				<h3 style={{ marginBottom: '20px' }}>
					<u>Queue current workers:</u>
				</h3>

				<Table
					className='styled-table styled-table-2'
					raws={raws}
					headers={headers}
				/>
			</Card>
		)
	);
};

export default QueueCurrentConsultant;
